// extracted by mini-css-extract-plugin
export const header = "HeaderNavBarLight-module--header--ec-vO";
export const headerContainer = "HeaderNavBarLight-module--header-container--2CjVn";
export const brandLogo = "HeaderNavBarLight-module--brand-logo--7KBML";
export const serviceNavbar = "HeaderNavBarLight-module--service-navbar--3GE6_";
export const secondaryNavbar = "HeaderNavBarLight-module--secondary-navbar--11xr3";